import Yox from 'yox'

import template from './template/ListItem.hbs'

import {
  FALSE,
  RAW_STRING,
} from '../constant'

import {
  findComponentUpward,
} from '../util'

export default Yox.define({

  template,

  name: 'bell-ListItem',

  propTypes: {
    className: {
      type: RAW_STRING,
    },
    style: {
      type: RAW_STRING,
    }
  },

  data(options) {
    const list = findComponentUpward(options.parent, 'bell-List')
    return {
      clickable: list
        ? list.get('clickable')
        : FALSE
    }
  }

})
